module.exports = __webpack_public_path__ + "static/media/upload.a3545544.svg";